import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";

export const updatetNWEASettings = (
  schoolId: number,
  gradeIds: number[],
  isNWEAEnabled: boolean,
  isBulkSyncEnabled: boolean,
  isLocked: boolean,
  updatedByUserId: number
) => {
  return AxiosHelper.axiosInstance().put(
    `${APIConstant.CMS_MINI_CRM_SCHOOLS_NWEA_GRADE_UPDATE}`,
    {
      schoolId: schoolId,
      gradeIds: gradeIds,
      isNWEAEnabled: isNWEAEnabled,
      isBulkSyncEnabled: isBulkSyncEnabled,
      isLocked: isLocked,
      updatedByUserId: updatedByUserId,
    }
  );
};

export const mapNWEASchools = (schoolId: number, updatedByUserId: number) => {
  return AxiosHelper.axiosInstance().put(
    `${APIConstant.CMS_MINI_CRM_SCHOOLS_NWEA_SCHOOL_MAP}`,
    {
      schoolId: schoolId,
      updatedByUserId: updatedByUserId,
    }
  );
};

export const getUnmappedNWEASchools = (schoolId: number) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_MINI_CRM_SCHOOLS_NWEA_SCHOOL_UNMAP}`,
    {
      params: {
        schoolId: schoolId,
      },
    }
  );
};

export const getNWEASettings = (schoolId: number) => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.CMS_MINI_CRM_SCHOOLS_NWEA_GRADE_GET,
    {
      params: {
        schoolId: schoolId,
      },
    }
  );
};

export const updateNWEASchoolId = (
  schoolId: number,
  nweaId: string | undefined,
  updatedByUserId: number
) => {
  return AxiosHelper.axiosInstance().put(
    `${APIConstant.CMS_MINI_CRM_SCHOOLS_NWEA_SCHOOL_Update}`,
    {
      schoolId: schoolId,
      nweaId: nweaId,
      updatedByUserId: updatedByUserId,
    }
  );
};
